module.exports = __webpack_public_path__ + "img/scene.11.487d5e82.jpg";